import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "placeholder"];
var __jsx = React.createElement;
import React from 'react';
import styles from '../styles/uploadPlaceholder.module.css';
import UploadIllustration from "./UploadIllustration";
import { useTranslation } from "@i18n";
export function UploadPlaceholder(_ref) {
  var className = _ref.className,
    placeholder = _ref.placeholder,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "".concat(styles.container, " ").concat(className)
  }, other), /*#__PURE__*/React.createElement("div", {
    className: styles.placeholder
  }, placeholder || t("upload_file", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement(UploadIllustration, null));
}
export default UploadPlaceholder;